// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input--reverse .v-input__slot{flex-direction:row-reverse;justify-content:flex-end}.v-application--is-ltr .v-input--reverse .v-input__slot .v-input--selection-controls__input{margin-right:0;margin-left:8px}.v-application--is-rtl .v-input--reverse .v-input__slot .v-input--selection-controls__input{margin-left:0;margin-right:8px}.v-input--expand .v-input__slot .v-label{display:block;flex:1}", ""]);
// Exports
module.exports = exports;
